import { ServiceType } from '@/finsight/domain/ServiceType';
import React from 'react';

export default {
  [ServiceType.ENTERPRISE]: {
    titleModal: <>Market Data<br />Enterprise Pricing</>,
    titleForm: 'Request a Quote',
    isCaptcha: true,
  },
  [ServiceType.API]: {
    titleModal: <>Market Data<br />API Integration</>,
    titleForm: 'Request a Quote',
    isCaptcha: true,
  },
  [ServiceType.BONDSCREENER_EXPORT]: {
    titleModal: <>US ABS Market<br />Data Export</>,
    titleForm: 'Market Data Export',
    isCaptcha: false,
  },
};
